import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/food_noimage.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-e7f756ca")

_pushScopeId("data-v-e7f756ca")
const _hoisted_1 = { class: "pantry-search-list-item-card" }
const _hoisted_2 = { class: "pantry-search-list-item-card-image" }
const _hoisted_3 = {
  key: 1,
  class: "pantry-search-list-item-card-image-noimage",
  src: _imports_0
}
const _hoisted_4 = { class: "pantry-search-list-item-card-title" }
const _hoisted_5 = {
  key: 1,
  class: "pantry-search-list-item-empty"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.isShow())
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: "pantry-search-list-item",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClick(...args)))
      }, [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            (_ctx.recipeImageUrl)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  class: "pantry-search-list-item-card-image-image",
                  src: _ctx.recipeImageUrl,
                  onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onImageError(...args)))
                }, null, 40, ["src"]))
              : (_openBlock(), _createBlock("img", _hoisted_3))
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", {
              innerHTML: _ctx.recipeLabel,
              class: "commonTextCaption2 pantry-search-list-item-card-title-text"
            }, null, 8, ["innerHTML"])
          ])
        ])
      ]))
    : (_openBlock(), _createBlock("div", _hoisted_5))
})